// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.qt-designer-form {
    overflow: auto;
    margin-bottom: 0.25em;
}
div.qt-designer-form label > input {
    margin-right: 0.25em;
}

div.qt-designer-layout-grid {
    display: grid;
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    height: 100%;
}

div.qt-designer-layout-grid > div {
    display: flex;
    align-items: center;
}

div.qt-designer-layout-grid > div > *:not(.qt-designer-form-vline) {
    width: 100%;
}

div.qt-designer-layout-vbox {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}

div.qt-designer-layout-hbox {
    display: flex;
    flex: 1 1 auto;
}

div.qt-designer-layout-hbox > div,
div.qt-designer-layout-vbox > div {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
}

div.qt-designer-form-hline {
    border-bottom: 1px solid var(--border-color);
}

div.qt-designer-form-vline {
    border-right: 1px solid var(--border-color);
    height: 100%;
}

div.qt-designer-form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

div.qt-designer-form-frame-title {
    font-weight: bold;
    flex: 0 0 auto;
}

div.qt-designer-form-frame {
    padding: 0.25em;
    flex: 1 1 auto;
    width: 100%;
}

div.qt-designer-form-frame-box {
    border: 1px solid var(--border-color);
}

div.qt-designer-form-tabbar {
    margin-bottom: -1px;
}

div.qt-designer-widget-relation {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    max-height: 6.5em;
}

div.qt-designer-widget-relation-resize-handle {
    touch-action: none;
    position: absolute;
    right: 1px;
    bottom: 1px;
    width: 0;
    height: 0;
    border-bottom: 10px solid var(--border-color);
    border-left: 10px solid transparent;
    z-index: 1;
    cursor: ns-resize;
}

div.qt-designer-widget-relation > div.ButtonBar {
    margin-top: -1px;
}

div.qt-designer-widget-relation-table-container {
    overflow-y: auto;
    flex: 1 1 auto;
    position: relative;
    border: 1px solid var(--border-color);
}

div.qt-designer-widget-relation-table-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200, 0.9);
    z-index: 2;
}

div.qt-designer-widget-relation-table-loading > div.spinner {
    width: 4em;
    height: 4em;
}

div.qt-designer-widget-relation-table-container > table {
    width: 100%;
}

div.qt-designer-widget-relation-table-container > table td {
    padding: 0.25em 0.125em;
    text-align: center;
}

div.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-record-icon {
    width: 1.5em;
}

td.qt-designer-widget-relation-record-icon > span.icon-trash:hover {
    color: red;
}

div.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-row-widget > * {
    width: 100%;
}

div.qt-designer-widget-relation-table-container > table td > label {
    display: block;
    text-align: center;
    white-space: nowrap;
}

div.qt-designer-widget-relation-table-container > table th {
    background-color: var(--border-color);
    color: white;
}

div.qt-designer-widget-relation-table-container > table tr:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
}

tr.qt-designer-widget-relation-record-deleted {
    background-color: rgb(255,127,127);
}

div.qt-designer-widget-relation-buttons {
    flex: 0 0 auto;
    display: flex;
}

div.qt-designer-widget-relation-buttons > button {
    flex: 1 1 auto;
}

div.qt-designer-form label {
    display: flex;
    align-items: center;
}

div.qt-designer-form div.text-input-wrapper-multiline {
    height: 100%;
}

div.qt-designer-form-featurelink-buttons {
    display: flex;
    align-items: center;
}

div.qt-designer-form-featurelink-buttons > button.button {
    flex: 1 1 auto;
}

div.qt-designer-form-featurelink-buttons > button.qt-designer-form-featurelink-clear {
    flex: 0 0 auto;
    margin: 0 0.25em;
}

div.qt-designer-report {
    background-color: white;
}

div.qt-designer-report input,
div.qt-designer-report select {
    border: none!important;
    outline: none!important;
}

div.qt-designer-report select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

div.qt-designer-form-textarea {
    padding: 0.25em;
    white-space: pre-wrap;
}

div.qt-designer-form-image img {
    width: 100%;
    max-width: 400px;
}

div.qt-designer-form-loading {
    display: flex;
    align-items: center;
    justify-content: center;
}

div.qt-designer-form-loading > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/QtDesignerForm.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6CAA6C;IAC7C,mCAAmC;IACnC,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB","sourcesContent":["div.qt-designer-form {\n    overflow: auto;\n    margin-bottom: 0.25em;\n}\ndiv.qt-designer-form label > input {\n    margin-right: 0.25em;\n}\n\ndiv.qt-designer-layout-grid {\n    display: grid;\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    height: 100%;\n}\n\ndiv.qt-designer-layout-grid > div {\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-layout-grid > div > *:not(.qt-designer-form-vline) {\n    width: 100%;\n}\n\ndiv.qt-designer-layout-vbox {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-layout-hbox {\n    display: flex;\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-layout-hbox > div,\ndiv.qt-designer-layout-vbox > div {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-form-hline {\n    border-bottom: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-form-vline {\n    border-right: 1px solid var(--border-color);\n    height: 100%;\n}\n\ndiv.qt-designer-form-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.qt-designer-form-frame-title {\n    font-weight: bold;\n    flex: 0 0 auto;\n}\n\ndiv.qt-designer-form-frame {\n    padding: 0.25em;\n    flex: 1 1 auto;\n    width: 100%;\n}\n\ndiv.qt-designer-form-frame-box {\n    border: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-form-tabbar {\n    margin-bottom: -1px;\n}\n\ndiv.qt-designer-widget-relation {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    max-height: 6.5em;\n}\n\ndiv.qt-designer-widget-relation-resize-handle {\n    touch-action: none;\n    position: absolute;\n    right: 1px;\n    bottom: 1px;\n    width: 0;\n    height: 0;\n    border-bottom: 10px solid var(--border-color);\n    border-left: 10px solid transparent;\n    z-index: 1;\n    cursor: ns-resize;\n}\n\ndiv.qt-designer-widget-relation > div.ButtonBar {\n    margin-top: -1px;\n}\n\ndiv.qt-designer-widget-relation-table-container {\n    overflow-y: auto;\n    flex: 1 1 auto;\n    position: relative;\n    border: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-widget-relation-table-loading {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200, 0.9);\n    z-index: 2;\n}\n\ndiv.qt-designer-widget-relation-table-loading > div.spinner {\n    width: 4em;\n    height: 4em;\n}\n\ndiv.qt-designer-widget-relation-table-container > table {\n    width: 100%;\n}\n\ndiv.qt-designer-widget-relation-table-container > table td {\n    padding: 0.25em 0.125em;\n    text-align: center;\n}\n\ndiv.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-record-icon {\n    width: 1.5em;\n}\n\ntd.qt-designer-widget-relation-record-icon > span.icon-trash:hover {\n    color: red;\n}\n\ndiv.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-row-widget > * {\n    width: 100%;\n}\n\ndiv.qt-designer-widget-relation-table-container > table td > label {\n    display: block;\n    text-align: center;\n    white-space: nowrap;\n}\n\ndiv.qt-designer-widget-relation-table-container > table th {\n    background-color: var(--border-color);\n    color: white;\n}\n\ndiv.qt-designer-widget-relation-table-container > table tr:not(:last-child) {\n    border-bottom: 1px solid var(--border-color);\n}\n\ntr.qt-designer-widget-relation-record-deleted {\n    background-color: rgb(255,127,127);\n}\n\ndiv.qt-designer-widget-relation-buttons {\n    flex: 0 0 auto;\n    display: flex;\n}\n\ndiv.qt-designer-widget-relation-buttons > button {\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-form label {\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-form div.text-input-wrapper-multiline {\n    height: 100%;\n}\n\ndiv.qt-designer-form-featurelink-buttons {\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-form-featurelink-buttons > button.button {\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-form-featurelink-buttons > button.qt-designer-form-featurelink-clear {\n    flex: 0 0 auto;\n    margin: 0 0.25em;\n}\n\ndiv.qt-designer-report {\n    background-color: white;\n}\n\ndiv.qt-designer-report input,\ndiv.qt-designer-report select {\n    border: none!important;\n    outline: none!important;\n}\n\ndiv.qt-designer-report select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\ndiv.qt-designer-form-textarea {\n    padding: 0.25em;\n    white-space: pre-wrap;\n}\n\ndiv.qt-designer-form-image img {\n    width: 100%;\n    max-width: 400px;\n}\n\ndiv.qt-designer-form-loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\ndiv.qt-designer-form-loading > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
